export function parseMarkdownDoc(raw) {
  const dateMatch = raw.match(/Last updated:\s*(.+)/i);
  const lastUpdated = dateMatch ? dateMatch[1].trim() : "";

  const sections = [];
  const sectionBlocks = raw.split(/\n(?=## )/);

  for (const block of sectionBlocks) {
    const match = block.match(/^## (.+?)\n([\s\S]*)/);
    if (!match) continue;
    const title = match[1].trim();
    const body = match[2].replace(/\n---\s*$/, "").trim();
    sections.push({ title, body });
  }

  return { lastUpdated, sections };
}
